// components/DynamicBackground.jsx
import { Box } from '@mui/material';

const DynamicBackground = ({ isConnected }) => (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh", 
      zIndex: -1,
      transition: 'all 0.8s ease-in-out',
      ...(isConnected ? {
        // 戰爭主題背景（連線成功）
        background: 'radial-gradient(circle at top left, #2d2d2d, #0d0d0d)',
        backgroundImage: `
          radial-gradient(circle at 20% 20%, rgba(255,0,0,0.15), transparent 40%),
          radial-gradient(circle at 80% 40%, rgba(255,255,0,0.1), transparent 40%),
          repeating-linear-gradient(45deg, rgba(255,0,0,0.08) 0px, transparent 2px, transparent 20px)
        `,
        backgroundBlendMode: 'overlay',
      } : {
        // 學術風格背景（連線中）
        backgroundColor: '#f6f4ea',
        backgroundImage: `
          radial-gradient(1000px 600px at 20% -10%, rgba(255,255,255,0.7), rgba(255,255,255,0) 60%), 
          radial-gradient(900px 500px at 120% 0%, rgba(255,255,255,0.55), rgba(255,255,255,0) 65%), 
          linear-gradient(180deg, rgba(0,0,0,0.03) 1px, transparent 1px), 
          linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)
        `,
        backgroundSize: 'auto, auto, 100% 28px, 28px 100%',
      })
    }}
  />
);

export default DynamicBackground;